import { faBoxHeart } from '@fa6/pro-solid-svg-icons/faBoxHeart'
import { faCassetteTape } from '@fa6/pro-solid-svg-icons/faCassetteTape'
import { faComputerClassic } from '@fa6/pro-solid-svg-icons/faComputerClassic'
import { faDiceD20 } from '@fa6/pro-solid-svg-icons/faDiceD20'
import { faFeatherAlt } from '@fa6/pro-solid-svg-icons/faFeatherAlt'
import { faFlashlight } from '@fa6/pro-solid-svg-icons/faFlashlight'
import { faFlaskPotion } from '@fa6/pro-solid-svg-icons/faFlaskPotion'
import { faForklift } from '@fa6/pro-solid-svg-icons/faForklift'
import { faGamepad } from '@fa6/pro-solid-svg-icons/faGamepad'
import { faGuitarElectric } from '@fa6/pro-solid-svg-icons/faGuitarElectric'
import { faPalette } from '@fa6/pro-solid-svg-icons/faPalette'
import { faPennant } from '@fa6/pro-solid-svg-icons/faPennant'
import { faPenNib } from '@fa6/pro-solid-svg-icons/faPenNib'
import { faPiggyBank } from '@fa6/pro-solid-svg-icons/faPiggyBank'
import { faPuzzlePiece } from '@fa6/pro-solid-svg-icons/faPuzzlePiece'
import { faRainbow } from '@fa6/pro-solid-svg-icons/faRainbow'
import { faRobot } from '@fa6/pro-solid-svg-icons/faRobot'
import { faRocket } from '@fa6/pro-solid-svg-icons/faRocket'
import { faRoute } from '@fa6/pro-solid-svg-icons/faRoute'
import { faScrewdriver } from '@fa6/pro-solid-svg-icons/faScrewdriver'
import { faShapes } from '@fa6/pro-solid-svg-icons/faShapes'
import { faSprayCan } from '@fa6/pro-solid-svg-icons/faSprayCan'
import { faSteeringWheel } from '@fa6/pro-solid-svg-icons/faSteeringWheel'
import { faStroopwafel } from '@fa6/pro-solid-svg-icons/faStroopwafel'
import { faSuitcase } from '@fa6/pro-solid-svg-icons/faSuitcase'
import { faSwatchbook } from '@fa6/pro-solid-svg-icons/faSwatchbook'
import { faToolbox } from '@fa6/pro-solid-svg-icons/faToolbox'
import { faTram } from '@fa6/pro-solid-svg-icons/faTram'
import { faTreePalm } from '@fa6/pro-solid-svg-icons/faTreePalm'
import { faTrophyStar } from '@fa6/pro-solid-svg-icons/faTrophyStar'
import { faTruckMonster } from '@fa6/pro-solid-svg-icons/faTruckMonster'

export default [
  faBoxHeart,
  faCassetteTape,
  faComputerClassic,
  faDiceD20,
  faFeatherAlt,
  faFlashlight,
  faFlaskPotion,
  faForklift,
  faGamepad,
  faGuitarElectric,
  faPalette,
  faPennant,
  faPenNib,
  faPiggyBank,
  faPuzzlePiece,
  faRainbow,
  faRobot,
  faRocket,
  faRoute,
  faScrewdriver,
  faShapes,
  faSprayCan,
  faSteeringWheel,
  faStroopwafel,
  faSuitcase,
  faSwatchbook,
  faToolbox,
  faTram,
  faTreePalm,
  faTrophyStar,
  faTruckMonster
]
